import React, { FC } from 'react';
import { Stepper as Component } from './Stepper';
import { StepperProps } from './types';
import { useStepper } from './useStepper';

export const Stepper: FC<StepperProps> = props => {
  const internalProps = useStepper(props.currentIndex);
  return <Component {...props} {...internalProps} />;
};
